import { useState, useEffect } from "react";
import { Button } from "./ui/button";
import { Download, X } from "lucide-react";

export function PWAInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      // Show banner only if not dismissed before
      const dismissed = localStorage.getItem("pwa-dismissed");
      if (!dismissed) setShowBanner(true);
    };
    window.addEventListener("beforeinstallprompt", handler);

    // Check if already installed
    const mqStandalone = window.matchMedia("(display-mode: standalone)");
    if (mqStandalone.matches || window.navigator.standalone) {
      setShowBanner(false);
    }

    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === "accepted") {
      setShowBanner(false);
    }
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setShowBanner(false);
    localStorage.setItem("pwa-dismissed", "1");
  };

  if (!showBanner) return null;

  return (
    <div
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:w-[360px] z-50 animate-in slide-in-from-bottom-4 duration-300"
      data-testid="pwa-install-banner"
    >
      <div className="bg-[#155155] text-white rounded-xl shadow-2xl p-4 flex items-center gap-3">
        <div className="h-10 w-10 rounded-lg bg-[#FBBA00] flex items-center justify-center shrink-0">
          <span className="text-[#155155] font-heading font-black text-lg">A</span>
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold font-heading">Install Ameenji CRM</p>
          <p className="text-[11px] text-white/70">Quick access from your home screen</p>
        </div>
        <Button
          size="sm"
          className="bg-[#FBBA00] hover:bg-[#e5aa00] text-[#155155] font-semibold text-xs h-8 px-3 shrink-0"
          onClick={handleInstall}
          data-testid="pwa-install-btn"
        >
          <Download size={13} className="mr-1" />
          Install
        </Button>
        <button
          onClick={handleDismiss}
          className="text-white/50 hover:text-white shrink-0 p-1"
          data-testid="pwa-dismiss-btn"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
